import { BaseApi } from './base.api.js';

export class ExplicitConsentMethodApi extends BaseApi {
    constructor(client) {
        super(client, '/explicit-consent-method');
    }
}
